import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { aiManagementApi } from '../../api/aiManagement.api';
import { PageHeader, Spinner, EmptyState, Badge, Btn } from '../../components/ui/index';
import { toPersian } from '../../utils/persianNumber';
import { useAutoRefresh } from '../../hooks/useAutoRefresh';
import { Buildings, Robot, Timer } from '@phosphor-icons/react';

export default function DispatcherDepartmentDashboard() {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback((showSpinner = true) => {
    if (showSpinner) setLoading(true);
    return aiManagementApi.getDispatcherDepartmentOverview()
      .then(r => setDepartments(Array.isArray(r.data) ? r.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);
  useAutoRefresh(() => load(false));

  return (
    <div className="fade-in">
      <PageHeader title="نمای دپارتمان‌ها" subtitle="وضعیت صف تیکت‌ها به تفکیک دپارتمان"
        action={<Btn variant="secondary" onClick={() => navigate('/dispatcher')}>صف دیسپچر</Btn>}
      />

      {loading ? <Spinner /> : departments.length === 0 ? <EmptyState icon={<Buildings size={44} weight="regular" />} title="دپارتمانی یافت نشد" /> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 16 }}>
          {departments.map(d => (
            <div key={d.department_id ?? d.department_name} style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 18 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', margin: 0 }}>{d.department_name}</h3>
                {d.overdue > 0 && <Badge variant="red">{toPersian(d.overdue)} دیرکرد</Badge>}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8, marginBottom: 12 }}>
                {[['در انتظار', d.waiting, '#b45309'], ['در حال بررسی', d.in_progress, '#29AAE1'], ['پاسخ‌داده‌شده', d.open_answered, '#059669'], ['بسته‌شده', d.closed, '#64748b']].map(([label, val, color]) => (
                  <div key={label} style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color }}>{toPersian(val)}</div>
                    <div style={{ fontSize: 9, color: '#94a3b8', marginTop: 2 }}>{label}</div>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#64748b', borderTop: '1px solid #f1f5f9', paddingTop: 10 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><Timer size={13} weight="regular" /> میانگین پاسخ: {d.avg_response_minutes != null ? `${toPersian(Math.round(d.avg_response_minutes))} دقیقه` : '—'}</span>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}><Robot size={13} weight="regular" /> استفاده از AI: {toPersian(d.ai_usage_percent)}%</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
